import React, { Component} from 'react';
import Auth from "../../Auth/Auth";
import { ContactTable } from '../../Components/Analytics/KPITables';

const auth = new Auth();
function parseJwt(token) {    
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  
    return JSON.parse(jsonPayload);
  }

export default class OnCall extends Component {
    constructor(props){
        super(props);

        this.state = {
            onCall: [],
            onCallContacts: [],           
            editDate: false,
            isLoading: false,
            onCallTemplate : false
        };
    }

    async componentDidMount(){
        let accessToken = await auth.getToken();
        let jwt = parseJwt(localStorage.getItem("msal.idtoken"));
        fetch(`${process.env.PUBLIC_URL}/config.json`)
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            let config = data.config
            if(config.OnCall.includes(jwt.oid)){
                this.setState({
                    onCallTemplate : true
                });
            }
        }).catch((error) => {
            window.apiError(error);
        });

        
        fetch('/api/getOnCallContacts', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            if(data && data[0]){
                this.setState({
                    onCallContacts : data[0],
                    isLoading: false
                });
            }
        }).catch((error) => {
            console.error('Error:', error);
            window.apiError(error);
        });             
    }

    render(){

        return (
            <div id="oncall" className="pl-3"  style={{ color: "#717171", fontSize: "14px"}}>
                 <div>
                    <div className="mb-3">
                        <strong>Contact Numbers</strong>
                    </div>
                    <ContactTable data={this.state.onCallContacts} />
                </div>
            </div>             
        );
    }
}